module.exports = "/images/vendor/flag-icon-css/flags/4x3/mv.svg?3c896bfdad2f76fe0945fe43d776a9ab";